"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_COLLECTION_UI_KEY = exports.FETCH_COLLECTIONS_UI_KEY = exports.DELETE_HOTEL_COLLECTION_UI_KEY = exports.DELETE_COLLECTION_UI_KEY = exports.CREATE_COLLECTION_UI_KEY = exports.COLLECTION_TYPES = exports.ADD_HOTEL_TO_COLLECTION_UI_KEY = void 0;
var FETCH_COLLECTIONS_UI_KEY = exports.FETCH_COLLECTIONS_UI_KEY = 'FETCH_COLLECTIONS_UI_KEY';
var ADD_HOTEL_TO_COLLECTION_UI_KEY = exports.ADD_HOTEL_TO_COLLECTION_UI_KEY = 'ADD_HOTEL_TO_COLLECTION_UI_KEY';
var CREATE_COLLECTION_UI_KEY = exports.CREATE_COLLECTION_UI_KEY = 'CREATE_COLLECTION_UI_KEY';
var DELETE_COLLECTION_UI_KEY = exports.DELETE_COLLECTION_UI_KEY = 'DELETE_COLLECTION_UI_KEY';
var DELETE_HOTEL_COLLECTION_UI_KEY = exports.DELETE_HOTEL_COLLECTION_UI_KEY = 'DELETE_HOTEL_COLLECTION_UI_KEY';
var UPDATE_COLLECTION_UI_KEY = exports.UPDATE_COLLECTION_UI_KEY = 'UPDATE_COLLECTION_UI_KEY';
var COLLECTION_TYPES = exports.COLLECTION_TYPES = {
  USER: 'user',
  TF: 'tf',
  PROJECT: 'project'
};